// Import the functions you need from the SDKs you need
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore, collection, addDoc } from 'firebase/firestore';
import { getFunctions, connectFunctionsEmulator } from 'firebase/functions';
import { getStorage } from 'firebase/storage';

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyD_oc56ntX3RHKhFi-277cnOY8jnFG9iq0",
  authDomain: "idea-farm-382512.firebaseapp.com",
  projectId: "idea-farm-382512",
  storageBucket: "idea-farm-382512.firebasestorage.app",
  messagingSenderId: "581845502293",
  appId: "1:581845502293:web:eb16c24f11d2cd95c607dc",
  measurementId: "G-G3SKSN7VJJ"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore, Auth, and Storage
const db = getFirestore(app);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);

// Configure functions to use auth automatically
// Note: Only connect to emulator in development if needed
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, 'localhost', 5001);
}

export const bookingsCollection = collection(db, 'bookings');
export const addBooking = async (data) => {
    await addDoc(bookingsCollection, data);
};
// Define a function to fetch services from Firestore


export { app, db, auth, functions, storage };
